<template>
  <el-dialog
    :visible.sync="sessionDialogVisible"
    width="456px"
    :before-close="handleClose"
    class="el-dialog--maia"
  >
    <div slot="title">
      当前待审批人
      <span class="count">{{sessionItem.appvUser && sessionItem.appvUser.length}}</span>
    </div>
    <div class="el-dialog__conetnt">
      <div v-for="(item, index) in sessionItem.appvUser" :key="index" class="user-box">
        <div class="left">
          <div class="user-img">
            <el-image :src="item.src">
              <div slot="error">
                <img src="../assets/images/avator.png" />
              </div>
            </el-image>
          </div>
          <div class="user-info">
            <div class="user-name">{{item.appvUserName}}({{item.appvUserAccount}})</div>
            <!-- <div class="user-org"></div> -->
          </div>
        </div>
        <div class="right">
          <img src="@/assets/images/session.svg" alt class="w-24 c-pointer" v-if="( item.appvUserAccount != sessionItem.pubUserAccount) && item.lxFlag == 1" @click="toDailogLongXin(item.appvUserName, item.appvUserAccount, sessionItem)"/>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="toSubmit" class="w-72">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ['sessionDialogVisible', 'sessionItem'],
  watch: {
    sessionItem: {
      handler(newVal, oldVal) {
        console.log(newVal, newVal.appvUser);
        if (newVal.appvUser && newVal.appvUser.length) {
          newVal.appvUser.forEach((item) => {
            this.$set(
              item,
              'src',
              `${this.imgUrl}/headImg/small/${item.appvUserAccount}.jpg`
            )
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    toSubmit() {
      this.$emit('update:sessionDialogVisible', false)
    },
    toDailogLongXin(realName, username, item) {
      this.$parent.toDailogLongXin(realName, username, item)
    },
    handleClose() {
      this.$emit('update:sessionDialogVisible', false)
    },
  },
};
</script>
<style scoped>
.el-dialog__conetnt {
  padding: 0 18px;
  height: 302px;
  overflow: auto;
}
.w-72 {
  width: 72px;
}
.user-box {
  display: flex;
  padding: 15px 0;
}
.left {
  flex: 1;
  display: flex;
}
.right {
  display: flex;
  align-items: center;
}
.left .user-img .el-image,
.left .user-img .el-image img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: block;
}
.left .user-info {
  margin-left: 12px;
  display: flex;
  align-items: center;
}
.user-info .user-name {
  color: #323232;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}
/* .user-info .user-org {
  color: #6f6f6f;
  font-size: 12px;
  line-height: 20px;
} */
.count {
  font-weight: 500;
}
</style>
